import { useNavigate } from 'react-router-dom'
import { useProjectStore } from '@/store/projectStore'
import { useJourneyAction } from '@/lib/journeyActions'
import { useJourneyStore } from '@/store/journeyStore'
import type { JourneyTab } from '@/api/journey'
import { advancedItem, openAdvancedItem } from './advanced'

/** A tab made of link cards (a website's Content / Visitors) — data from tabs.json. */
export default function HubTab({ tab }: { tab: JourneyTab }) {
  const navigate = useNavigate()
  const project = useProjectStore((s) => s.currentProject?.application.folder_name || '')
  const run = useJourneyAction()
  const catalog = useJourneyStore((s) => s.journey?.tab_catalog || [])
  const allTabs = (tab.items || [])
  return (
    <div className="swb swb-page">
      <div className="swb-head">
        <div>
          <h1>{tab.label}</h1>
          {tab.intro && <p>{tab.intro}</p>}
        </div>
      </div>
      <div className="swb-grid">
        {allTabs.map((id) => {
          if (id.startsWith('tab:')) {
            const t = catalog.find((c) => c.id === id.slice(4))
            if (!t) return null
            return (
              <button key={id} type="button" className="swb-tile" onClick={() => void run(id)}>
                <strong><span className="material-icons" style={{ fontSize: 19, color: 'var(--color-accent)' }}>list_alt</span>
                  {t.label}</strong>
                {t.intro && <span className="swb-muted">{t.intro}</span>}
              </button>
            )
          }
          const item = advancedItem(id)
          if (!item) return null
          return (
            <button key={id} type="button" className="swb-tile" onClick={() => openAdvancedItem(item, project, navigate, run)}>
              <strong><span className="material-icons" style={{ fontSize: 19, color: 'var(--color-accent)' }}>{item.icon}</span>{item.title}</strong>
              <span className="swb-muted">{item.line}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
